export default "__VITE_ASSET__rREVcUp4__"